import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicRoute from "./public-route";
import PrivateRoute from "./private-route";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from "../pages/dashborad/dashborad"
import Registration from "../pages/auth/registration";
import UserList from "../pages/organization-list/organization-list";
import DoctorList from "../pages/doctor-list/doctor-list";
// import UserRole from "../pages/user-role";
import Login from "../pages/auth/login";
import LocationList from "../pages/addLocations/locationList";
import UserDetails from "../pages/user-details/userDetails";
import LocationDetails from "../pages/organization-list/locationDetails";
import AdminList from "../pages/admin/adminList";
import OrderList from "../pages/order-list/order-list";
import OrderCreate from "../pages/order-list/order-create";
import OrderUpdate from "../pages/doctor-list/order-update";
import DoctorCreatePage from "../pages/doctor-list/doctor-create-page";
import CreateStaff from "../pages/doctor-list/create-staff";
import MostPrescribedMedicines from "../pages/reports/most-prescribed-medicines";
import DoctorWiseAppointmentStats from "../pages/reports/doctor-wise-appointment-stats";
import PermissionList from "../pages/permissions/permission-list";
import RoleList from "../pages/roles/role-list";
import RolePermissions from "../pages/roles/role-permissions";
import FollowupTestList from "../pages/followup-test/followup-test-list";
import DoctorDataTransfer from "../pages/data-transfer/doctor-data-transfer";
import SpecialityList from "../pages/speciality/speciality-list";
import MedicineList from "../pages/medicine/medicine-list";


const AppRoutes = () => {
    return (
        <BrowserRouter>
            <ToastContainer />
            <Routes>
                <Route element={<PublicRoute />}>
                    <Route path="/login" element={<Login />}></Route>
                    <Route path="/registration" element={<Registration />}></Route>

                </Route>
                <Route element={<PrivateRoute />}>
                    <Route path="/" element={<Dashboard />}></Route>
                    <Route path="/dashboard" element={<Dashboard />}></Route>
                    <Route path="/organization-list" element={<UserList />}></Route>
                    <Route path="/doctor-list" element={<DoctorList />}></Route>
                    {/*<Route path="/user-role" element={<UserRole/>}></Route>*/}
                    <Route path="/user-detail/:id" element={<UserDetails />}></Route>
                    <Route path="/location-detail/:id" element={<LocationDetails />}></Route>
                    <Route path="/location" element={<LocationList/>}></Route>
                    <Route path="/admin-list" element={<AdminList/>}></Route>
                    <Route path="/order-list" element={<OrderList/>}></Route>
                    <Route path="/order-create" element={<OrderCreate/>}></Route>
                    <Route path="/order/:id" element={<OrderUpdate/>}></Route>
                    <Route path="/doctor-create-page" element={<DoctorCreatePage/>}></Route>
                    <Route path="/create-staff" element={<CreateStaff/>}></Route>
                    <Route path="/report/most-prescribed-medicines" element={<MostPrescribedMedicines />}></Route>
                    <Route path="/report/doctor-wise-appointment-stats" element={<DoctorWiseAppointmentStats />}></Route>
                    <Route path="/permissions" element={<PermissionList />}></Route>
                    <Route path="/roles" element={<RoleList />}></Route>
                    <Route path="/roles/:roleId/permissions" element={<RolePermissions />}></Route>
                    <Route path="/followup-test-list" element={<FollowupTestList />}></Route>
                    <Route path="/doctor-data-transfer" element={<DoctorDataTransfer />}></Route>
                    <Route path="/speciality-list" element={<SpecialityList />}></Route>
                    <Route path="/medicine-list" element={<MedicineList />}></Route>
                    <Route path="*" element={<h1>404 not found</h1>}></Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;
